// carryForwardProps.js — PURE helper for the Video block's "carry forward last
// style" mount effect (see index.jsx). No React, no craft.js, no Redux: just a
// deterministic patch-computation so the field list is unit-testable in
// isolation and the leak fixed in WEB-034 can't silently regress.
//
// WEB-034 (audits/FINDINGS-REGISTER.md): the mount effect used to also copy
// `hyperlink` / `showHyperlink` from the shared "last used" store onto a
// brand-new block. That's a click DESTINATION — content, not decoration — and
// every other content field in this codebase (image src, video src, text
// copy, linked Wheel id) is deliberately excluded from carry-forward with a
// comment explaining why. `hyperlink`/`showHyperlink` were the one exception,
// missed. They are intentionally NOT in the patch below.
//
// Only fields that are currently `undefined` on `props` (i.e. a genuinely new
// block, per craft.js's own `VideoDefaultProps`) are ever copied forward.

export const getVideoCarryForwardPatch = (props, videoProps) => {
  const patch = {};

  if (props.margin === undefined) {
    patch.margin = { ...videoProps.margin };
  }

  if (props.isApplyMarginOnAllSides === undefined) {
    patch.isApplyMarginOnAllSides = videoProps.isApplyMarginOnAllSides;
  }

  if (props.allSideMargin === undefined) {
    patch.allSideMargin = videoProps.allSideMargin;
  }

  if (props.width === undefined) {
    patch.width = videoProps.width;
  }

  if (props.borderRadius === undefined) {
    patch.borderRadius = videoProps.borderRadius;
  }

  if (props.borderWidth === undefined) {
    patch.borderWidth = videoProps.borderWidth;
  }

  if (props.borderColor === undefined) {
    patch.borderColor = videoProps.borderColor || "suggested_color_0";
  }

  if (props.dropShadowColor === undefined) {
    patch.dropShadowColor = videoProps.dropShadowColor;
  }

  if (props.showVideoTitle === undefined) {
    patch.showVideoTitle = videoProps.showVideoTitle;
  }

  // WEB-034: hyperlink / showHyperlink are content (a click destination), not
  // style — deliberately excluded from carry-forward. Do not add them back
  // without a product decision; see audits/block-style-carryforward-assessment.md §3.5.

  if (props.title === undefined) {
    patch.title = videoProps.title;
  }

  return patch;
};
